import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

export default function CommentClickPlugin({ onCommentClick }) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const root = editor.getRootElement();
    if (!root) return;

    const handleClick = (e) => {
      const el = e.target.closest('[data-comment-id]');
      if (el) {
        const id = el.getAttribute('data-comment-id');
        onCommentClick(id);
      }
    };

    root.addEventListener('click', handleClick);
    return () => root.removeEventListener('click', handleClick);
  }, [editor, onCommentClick]);

  return null;
}
